import { PageContainer } from '../../shared/PageContainer';
import ListIcon from '@mui/icons-material/List';
import { PageDefaultSegment } from '@sis/react-library';

export const ListAndDetailSamplesAboutPage = () => {
    return (
        <PageContainer heading='List Samples - About' icon={<ListIcon />}>
            <PageDefaultSegment>
                <h3>Usage</h3>
                To use the list, you need 3 component pages.
                <ul>
                    <li>A list page component where the 'list and detail' component resides.</li>
                    <li>A new page component for when creating a new record.</li>
                    <li>An update component page for updating a record.</li>
                </ul>
                <br />
                <h3>Advantages</h3>
                <ul>
                    <li>Removes boiler plate code for lists with new/edit pages.</li>
                    <li>Keeps the look and feel consistent.</li>
                    <li>
                        Is responsive, has rendering for mobile built in.<br />
                        <i>(the view in mobile looks quite different than desktop and is optomised for a better mobile experience)</i>
                    </li>
                </ul>

                <br />
                The code for these samples can be found in <i>'src/components/listAndDetailSamples/listAndDetailSamplesPages/'</i>.
            </PageDefaultSegment>
        </PageContainer>
    )
}
